/**
 * Returns a `Promise` that returns after the supplied delay.
 * @param {number} delayInMs The number of milliseconds to delay/wait for.
 * @param {AbortSignal} abortSignal When aborted, the `abortSignal` will cancel the in-progress timeout.
 * @returns {Promise<void>} A `Promise` that can be awaited.
 */
export function delay(delayInMs: number, abortSignal?: AbortSignal): Promise<void> {
    return new Promise<void>((resolve) => {
        let timeout: null | ReturnType<typeof setTimeout> = null;

        function handleAbort() {
            if (timeout) {
                clearTimeout(timeout);
            }
        }

        timeout = setTimeout(() => {
            if (abortSignal) {
                abortSignal.removeEventListener("abort", handleAbort);
            }
            resolve();
        }, delayInMs);

        if (abortSignal) {
            abortSignal.addEventListener("abort", handleAbort);
        }
    });
}
